const initialState = {
  stepsValidity: [],
  showErrors: true
}

function stepBoxReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_STEPBOX_ERRORS': {
      return {
        ...state,
        stepsValidity: action.stepsValidity
      }
    }
    case 'SHOW_STEPBOX_ERRORS': {
      return {
        ...state,
        showErrors: action.showErrors
      }
    }
    default:
      return state
  }
}

export default stepBoxReducer



// WEBPACK FOOTER //
// ./src/app/modules/StepBox/reducer.js